
<div [ngClass]="contentClassName" >

	            <div [ngClass]="tableClassName" class="mat-elevation-z1" style="outline:none;"
                  tabindex="-1">
                <table mat-table [dataSource]="dataSource" >
                    <!-- selected -->
                      <ng-container matColumnDef="selected">
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-override"
                            style="width: 50px">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                  [(ngModel)]="topCheck"
                                  [disabled]="!isEditing"
                                  (change)="toggleAllSelected($event)"></mat-checkbox>
                        </th>
                        <td mat-cell style="width:25% !important;"
                            *matCellDef="let element"> <mat-checkbox [disabled]="!isEditing" binary="true" [(ngModel)]="element.selected"></mat-checkbox>
                        </td>
                    </ng-container>
                    
                       <ng-container matColumnDef="enable_auto_match">
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-override"
                            style="text-align:center;width: 25%">Auto Match
                        </th>
                       <td mat-cell style="width:25% !important;text-align:center;" *matCellDef="let element">
						  <mat-checkbox
                            *ngIf="element.selected===true"
						    [disabled]="!isEditing" binary="true"
						    [(ngModel)]="element.useForAutomatch"
						    (change)="onCheckboxChange($event, element)"
						  ></mat-checkbox>
						</td>
                    </ng-container>
                    <ng-container matColumnDef="required">
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-override"
                            style="text-align:center; width: 25%">Req'd
                        </th>
                        <td mat-cell style="width:25% !important;text-align:center;"
                            *matCellDef="let element">
                            <mat-checkbox  *ngIf="element.selected===true" binary="true" [disabled]="!isEditing"
                                             [(ngModel)]="element.required"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef
                            class="table-header-style-override"
                            style="width: 50%">Description
                        </th>
                        <td mat-cell style="width:50% !important;"
                            *matCellDef="let element">{{ element.description }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>
               <!-- <app-dw-spinner [visible]="busyCursor"></app-dw-spinner> -->
            </div>


    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div class="save-close-strip" style="bottom: 3px;">

        <button mat-button class="command-button" *ngIf="!this.isEditing && modifyEnabled"
                [disabled]="masterQualificationId === 0 "
                (click)="modifyHandler()" matTooltip="Save the record"
                mat-button>
            <mat-icon>edit</mat-icon>
            Edit
        </button>

        <button mat-button class="command-button" *ngIf="this.isEditing"
                (click)="saveClickedEvent()" matTooltip="Save the record"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button mat-button class="command-button" *ngIf="this.isEditing"
                (click)="cancelClickedEvent()" matTooltip="Cancel edits" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
